module.exports = __webpack_public_path__ + "static/media/resume.fb31f67a.pdf";